import React, { cloneElement, Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { NavLink } from 'react-router-dom';
import MenuItem from '@material-ui/core/MenuItem';
import { withStyles, createStyles } from '@material-ui/core/styles';

const styles = theme => createStyles({
    root: {
        color: theme.palette.text.secondary,
        display: 'flex',
        alignItems: 'flex-start',
    },
    active: {
        color: theme.palette.text.primary,
    },
    icon: { paddingRight: '1.2em' },
});

export class MenuItemLink extends Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        className: PropTypes.string,
        leftIcon: PropTypes.node,
        onClick: PropTypes.func,
        primaryText: PropTypes.node,
        staticContext: PropTypes.object,
        children: PropTypes.node,
        to: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
            .isRequired,
    };

    handleMenuTap = e => {
        this.props.onClick && this.props.onClick(e);
    };

    render() {
        const {
            classes,
            className,
            primaryText,
            leftIcon,
            staticContext,
            children,
            ...props
        } = this.props;        

        return (
            <div>
                <MenuItem
                    className={classnames(classes.root, className)}
                    activeClassName={classes.active}
                    component={NavLink}
                    {...props}
                    onClick={this.handleMenuTap}
                >
                    {leftIcon && (
                        <span className={classes.icon}>
                            {cloneElement(leftIcon, { titleAccess: primaryText })}
                        </span>
                    )}
                    {primaryText}
                </MenuItem>
                {
                    children
                }
            </div>
        );
    }
}

export default withStyles(styles)(MenuItemLink);